import React from "react";
import AIAssistantSetting from "./_components/AIAssistantSetting";

const AIAssistant = () => {
  return <AIAssistantSetting />;
};

export default AIAssistant;
